import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthQuery } from "../lib/api/auth";
import { navItemsForRole, routeAllowedForRole } from "../lib/navigation";

export function RoleRouteGuard({ children }: { children: ReactNode }) {
  const location = useLocation();
  const auth = useAuthQuery();
  const user = auth.data;

  if (!user) {
    return children;
  }

  if (routeAllowedForRole(location.pathname, user.role, user.unitIds)) {
    return children;
  }

  const fallback = navItemsForRole(user.role, user.unitIds)[0]?.to ?? "/";
  return <Navigate to={fallback} replace state={{ denied: location.pathname }} />;
}
